import OrganizationPosts from "./OrganizationPosts";
export default OrganizationPosts;
